var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.157,
    height: 131.173,
    viewBox: "0 0 160.157 131.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_930",
    "data-name": "Grupo 930",
    transform: "translate(12510.078 -12852.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_my_documents_re_13dc",
    transform: "translate(-12510.078 12852.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15861",
    "data-name": "Trazado 15861",
    d: "M521.178,165.378a57.19,57.19,0,0,1-66.548,56.447q-1.339-.218-2.66-.5-1.789-.38-3.536-.874a57.213,57.213,0,1,1,72.743-55.07Z",
    transform: "translate(-367.477 -108.171)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16125",
    "data-name": "Trazado 16125",
    d: "M800.484,64.971s-3.166-16.8,9.125-19.871,13.03,14.37,13.03,14.37,13.375,2.545,13.463,15.552c.109,16.256-15.6,13.523-15.6,13.523l-14.88-6.061s-14.9-8.117-5.135-17.512",
    transform: "translate(-712.122 -17.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15862",
    "data-name": "Trazado 15862",
    d: "M507.176,401.96a.431.431,0,0,0-.177.583l21.508,40.285a.431.431,0,0,0,.583.177l30.4-16.233a.431.431,0,0,0,.177-.583L538.163,385.9a.431.431,0,0,0-.583-.177Z",
    transform: "translate(-446.513 -327.097)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15863",
    "data-name": "Trazado 15863",
    d: "M515.024,414.551l19.682,36.864,26.983-14.406-19.682-36.865Zm-1.71.913,0,0,0,0Z",
    transform: "translate(-451.535 -338.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15864",
    "data-name": "Trazado 15864",
    d: "M552.213,447.875a1.068,1.068,0,0,0-.2,1.456c.309.579.9.868,1.321.645L573.1,439.425a1.068,1.068,0,0,0,.2-1.456c-.309-.579-.9-.868-1.321-.645Z",
    transform: "translate(-481.919 -367.782)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15865",
    "data-name": "Trazado 15865",
    d: "M563.747,469.48a1.068,1.068,0,0,0-.2,1.456c.309.579.9.868,1.321.645l19.763-10.551a1.068,1.068,0,0,0,.2-1.456c-.309-.579-.9-.868-1.321-.645Z",
    transform: "translate(-491.019 -384.826)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15866",
    "data-name": "Trazado 15866",
    d: "M575.282,491.084a1.068,1.068,0,0,0-.2,1.456c.309.579.9.868,1.321.645l19.763-10.551a1.068,1.068,0,0,0,.2-1.456c-.309-.579-.9-.868-1.321-.645Z",
    transform: "translate(-500.119 -401.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15867",
    "data-name": "Trazado 15867",
    d: "M586.816,512.688a1.068,1.068,0,0,0-.2,1.456c.309.579.9.868,1.321.645L607.7,504.238a1.068,1.068,0,0,0,.2-1.456c-.309-.579-.9-.868-1.321-.645Z",
    transform: "translate(-509.218 -418.914)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15868",
    "data-name": "Trazado 15868",
    d: "M598.351,534.293a1.068,1.068,0,0,0-.2,1.456c.309.579.9.868,1.321.645l19.763-10.551a1.068,1.068,0,0,0,.2-1.456c-.309-.579-.9-.868-1.321-.645Z",
    transform: "translate(-518.318 -435.957)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15870",
    "data-name": "Trazado 15870",
    d: "M651.6,547.864l.046.557a57.578,57.578,0,0,1-28.069,2.377l-2.66-.5,2.531-5.613L625.1,541l-.6-12.729-.063-1.317-.078-1.68,1.081-.006,7.684-.046,7.323-.046,1.117-.006C648.572,533.784,654.35,540.784,651.6,547.864Z",
    transform: "translate(-536.421 -437.145)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15871",
    "data-name": "Trazado 15871",
    d: "M648.557,401.563l-17.1,1.9-.633-11.821c-2.007-5.118-.682-9.686,3.483-13.785l.847-3.351a4.962,4.962,0,0,1,3.665-3.612h0a17.666,17.666,0,0,1,9.527-2.261h0a7.109,7.109,0,0,1,4.5,7.174A131.705,131.705,0,0,1,648.557,401.563Z",
    transform: "translate(-543.513 -313.643)",
    fill: "#ff684b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15873",
    "data-name": "Trazado 15873",
    d: "M220.808,414.429a.211.211,0,0,0-.15.258l5.761,21.622a.211.211,0,0,0,.258.15L243,432.111a.211.211,0,0,0,.15-.258l-5.761-21.622a.211.211,0,0,0-.258-.15Z",
    transform: "translate(-220.652 -346.344)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15874",
    "data-name": "Trazado 15874",
    d: "M239.326,437.019a.524.524,0,0,0-.258.672c.083.311.333.515.558.455l10.607-2.826a.524.524,0,0,0,.258-.672c-.083-.311-.333-.515-.558-.455Z",
    transform: "translate(-235.16 -365.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15875",
    "data-name": "Trazado 15875",
    d: "M242.416,448.615a.524.524,0,0,0-.258.672c.083.311.333.515.558.455l10.607-2.826a.523.523,0,0,0,.258-.672c-.083-.311-.333-.515-.558-.455Z",
    transform: "translate(-237.597 -374.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15876",
    "data-name": "Trazado 15876",
    d: "M245.505,460.21a.523.523,0,0,0-.258.672c.083.311.333.515.558.455l10.607-2.826a.524.524,0,0,0,.258-.672c-.083-.311-.333-.515-.558-.455Z",
    transform: "translate(-240.034 -383.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15877",
    "data-name": "Trazado 15877",
    d: "M248.594,471.806a.523.523,0,0,0-.258.672c.083.311.333.515.558.455l10.607-2.826a.523.523,0,0,0,.258-.672c-.083-.311-.333-.515-.558-.455Z",
    transform: "translate(-242.471 -392.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15878",
    "data-name": "Trazado 15878",
    d: "M251.684,483.4a.523.523,0,0,0-.258.672c.083.311.333.515.558.455l10.607-2.826a.523.523,0,0,0,.258-.672c-.083-.311-.333-.515-.558-.455Z",
    transform: "translate(-244.909 -401.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15879",
    "data-name": "Trazado 15879",
    d: "M254.773,495a.523.523,0,0,0-.258.672c.083.311.333.515.558.455l10.607-2.826a.523.523,0,0,0,.258-.672c-.083-.311-.333-.515-.558-.455Z",
    transform: "translate(-247.346 -411.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15880",
    "data-name": "Trazado 15880",
    d: "M223.813,326.971a.211.211,0,0,0-.087.286L234.264,347a.211.211,0,0,0,.286.087l14.9-7.954a.211.211,0,0,0,.087-.286L239,319.1a.211.211,0,0,0-.286-.087Z",
    transform: "translate(-223.057 -274.49)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15881",
    "data-name": "Trazado 15881",
    d: "M227.658,333.141,237.3,351.2l13.221-7.059-9.644-18.063Zm-.838.447h0Z",
    transform: "translate(-225.518 -280.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15882",
    "data-name": "Trazado 15882",
    d: "M245.879,349.469a.523.523,0,0,0-.1.714c.151.284.442.426.647.316l9.683-5.17a.524.524,0,0,0,.1-.714c-.151-.284-.442-.425-.647-.316Z",
    transform: "translate(-240.406 -294.425)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15883",
    "data-name": "Trazado 15883",
    d: "M251.531,360.055a.523.523,0,0,0-.1.714c.151.284.442.426.647.316l9.683-5.17a.524.524,0,0,0,.1-.714c-.151-.284-.442-.426-.647-.316Z",
    transform: "translate(-244.864 -302.776)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15884",
    "data-name": "Trazado 15884",
    d: "M257.183,370.64a.523.523,0,0,0-.1.714c.151.284.442.426.647.316l9.683-5.17a.523.523,0,0,0,.1-.714c-.151-.284-.442-.426-.647-.316Z",
    transform: "translate(-249.323 -311.127)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15885",
    "data-name": "Trazado 15885",
    d: "M262.835,381.226a.523.523,0,0,0-.1.714c.151.284.442.426.647.316l9.683-5.17a.523.523,0,0,0,.1-.714c-.151-.284-.442-.426-.647-.316Z",
    transform: "translate(-253.782 -319.478)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15886",
    "data-name": "Trazado 15886",
    d: "M268.486,391.812a.523.523,0,0,0-.1.714c.151.284.442.426.647.316l9.683-5.17a.524.524,0,0,0,.1-.714c-.151-.284-.442-.426-.647-.316Z",
    transform: "translate(-258.24 -327.829)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15887",
    "data-name": "Trazado 15887",
    d: "M274.138,402.4a.523.523,0,0,0-.1.714c.151.284.442.426.647.316l9.683-5.17a.524.524,0,0,0,.1-.714c-.151-.284-.442-.426-.647-.316Z",
    transform: "translate(-262.699 -336.18)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15888",
    "data-name": "Trazado 15888",
    d: "M866.25,595.637a.211.211,0,0,0-.289.074l-11.384,19.264a.211.211,0,0,0,.074.289l14.539,8.592a.211.211,0,0,0,.289-.074l11.384-19.264a.211.211,0,0,0-.074-.289Z",
    transform: "translate(-720.736 -492.712)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15889",
    "data-name": "Trazado 15889",
    d: "M872.129,600.964l-10.417,17.628,12.9,7.625,10.417-17.628Zm-.818-.483h0Z",
    transform: "translate(-726.388 -496.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15890",
    "data-name": "Trazado 15890",
    d: "M908.371,620.987a.614.614,0,0,0-.594,1l9.45,5.585a.614.614,0,0,0,.594-1Z",
    transform: "translate(-762.593 -512.7)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15891",
    "data-name": "Trazado 15891",
    d: "M902.266,631.318a.614.614,0,0,0-.594,1l9.45,5.585a.614.614,0,0,0,.594-1Z",
    transform: "translate(-757.777 -520.85)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15892",
    "data-name": "Trazado 15892",
    d: "M896.161,641.649a.614.614,0,0,0-.594,1l9.45,5.584a.614.614,0,0,0,.594-1Z",
    transform: "translate(-752.96 -529)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15893",
    "data-name": "Trazado 15893",
    d: "M890.056,651.98a.614.614,0,0,0-.594,1l9.45,5.585a.614.614,0,0,0,.594-1Z",
    transform: "translate(-748.144 -537.15)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15894",
    "data-name": "Trazado 15894",
    d: "M883.951,662.311a.614.614,0,0,0-.594,1l9.45,5.584a.614.614,0,0,0,.594-1Z",
    transform: "translate(-743.328 -545.3)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15895",
    "data-name": "Trazado 15895",
    d: "M877.846,672.642a.614.614,0,0,0-.594,1l9.45,5.584a.614.614,0,0,0,.594-1Z",
    transform: "translate(-738.512 -553.45)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15896",
    "data-name": "Trazado 15896",
    d: "M608.27,429.671l-.219,1.359-2.314,14.262-1.452,4.638-.511,1.632-.428,1.372-5.208,16.634-1.429,3.357a4.01,4.01,0,1,0,4.689,1.48l10.193-23.711.378-.811,1.157-2.48,2.185-16.484.137-1.036Z",
    transform: "translate(-515.26 -361.805)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15897",
    "data-name": "Trazado 15897",
    d: "M665.764,390.324a12.442,12.442,0,0,0-9.5,0l.979-8.485a4.047,4.047,0,0,1,3.832-4.178h0a4.047,4.047,0,0,1,4.254,3.829v.014Z",
    transform: "translate(-564.309 -320.769)",
    fill: "#ff684b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_917",
    "data-name": "Grupo 917",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16107",
    "data-name": "Trazado 16107",
    d: "M883.31,228.384v.18l.151,3.385.108,2.654s-.227.617,2.863.417c4.14-.284,5.475-2.063,5.475-2.063l.176-6.221-1.255.239Z",
    transform: "translate(-13298.163 12674.784)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16112",
    "data-name": "Trazado 16112",
    d: "M883.32,230.444l.151,3.385c2.012-.244,5.674-1.115,7.153-4.28a2.564,2.564,0,0,0,.214-.681l-7.505,1.525Z",
    transform: "translate(-13298.172 12672.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16108",
    "data-name": "Trazado 16108",
    d: "M851.59,86.036s-3.851,8.813-2.463,13.764,5.9,4.172,8.6,3.215a8.933,8.933,0,0,0,3.952-2.612,3.805,3.805,0,0,0,4.208-1.49c1.686-2.344.648-5.037-.792-5.654a3.959,3.959,0,0,0-3.151.422l1.342-2.561S857.637,78.1,851.59,86.036",
    transform: "translate(-13267.754 12801.112)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16117",
    "data-name": "Trazado 16117",
    d: "M882.3,64.26a7.338,7.338,0,0,0,4.438,6.82c4.717,2.131,7.868,1.708,7.868,1.708l-.306-6.115-5.9-6.414-5.279,1.682Z",
    transform: "translate(-13297.273 12821.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16113",
    "data-name": "Trazado 16113",
    d: "M957.084,158.393l.018,2.67,2.375-2.343Z",
    transform: "translate(-13363.217 12735.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16109",
    "data-name": "Trazado 16109",
    d: "M875.238,281.362a15.232,15.232,0,0,1-3.372-.362.317.317,0,0,1,.152-.615c.056.014,5.643,1.347,9.478-1.449a.317.317,0,0,1,.373.513,11.241,11.241,0,0,1-6.631,1.914",
    transform: "translate(-13287.858 12628.808)",
    fill: "#7772d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16122",
    "data-name": "Trazado 16122",
    d: "M860.587,123.553a.317.317,0,0,1-.095-.619l1.756-.549a.317.317,0,0,1,.189.6l-1.756.549a.315.315,0,0,1-.095.015",
    transform: "translate(-13277.847 12766.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16110",
    "data-name": "Trazado 16110",
    d: "M958.944,181.256a.317.317,0,0,1-.215-.55l2.717-2.5a.317.317,0,0,1,.429.467l-2.717,2.5a.314.314,0,0,1-.214.084",
    transform: "translate(-13364.577 12717.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16111",
    "data-name": "Trazado 16111",
    d: "M970.133,191.812a.319.319,0,0,1-.127-.027l-1.621-.712a.317.317,0,0,1,.255-.581l1.621.712a.317.317,0,0,1-.128.607",
    transform: "translate(-13373.015 12706.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16119",
    "data-name": "Trazado 16119",
    d: "M862.313,146.113a.326.326,0,0,1-.065-.007.317.317,0,0,1-.246-.375l.324-1.56-.637-.734a.317.317,0,1,1,.478-.415l.74.853a.316.316,0,0,1,.071.272l-.355,1.714a.317.317,0,0,1-.31.252",
    transform: "translate(-13279.029 12748.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16116",
    "data-name": "Trazado 16116",
    d: "M907.269,148.4a.334.334,0,0,1-.065-.006.317.317,0,0,1-.246-.375l.324-1.56-.637-.734a.317.317,0,1,1,.479-.415l.74.853a.316.316,0,0,1,.071.272l-.355,1.714a.317.317,0,0,1-.31.253",
    transform: "translate(-13318.672 12746.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16118",
    "data-name": "Trazado 16118",
    d: "M873.027,168.093a.317.317,0,0,1-.31-.252,4.735,4.735,0,0,1,.833-4.3.317.317,0,0,1,.452.445,4.14,4.14,0,0,0-.665,3.722.317.317,0,0,1-.245.375.31.31,0,0,1-.065.007",
    transform: "translate(-13288.692 12730.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16115",
    "data-name": "Trazado 16115",
    d: "M887.985,208.038c-.188,0-.638-.087-1.577-1.127a.463.463,0,0,1-.105-.436.49.49,0,0,1,.336-.334c2.262-.677,2.569-.445,2.7-.346a.6.6,0,0,1,.157.711c-.172.578-.892,1.493-1.455,1.531l-.056,0m-.928-1.359a2.662,2.662,0,0,0,.943.725,1.294,1.294,0,0,0,.527-.454,1.969,1.969,0,0,0,.37-.654,9.363,9.363,0,0,0-1.84.383",
    transform: "translate(-13300.786 12693.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16120",
    "data-name": "Trazado 16120",
    d: "M820.515,96.472A3.2,3.2,0,0,0,818.4,98.1a1.9,1.9,0,0,0-.115.909,2.227,2.227,0,0,0,.485,1.033c1.471,1.759,7.518,1.612,7.518,1.612,4.057-.1,6.208-.38,9.577-.529,1.89-.084,3.5-.1,4.7-.087a.092.092,0,0,0,.02-.183l-20.077-4.383",
    transform: "translate(-13240.814 12789.65)",
    fill: "#c6783a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16114",
    "data-name": "Trazado 16114",
    d: "M962.744,121.578l1.719,5.3a4.339,4.339,0,0,1,2.437,1.951,3.578,3.578,0,0,1,.276.676l.446-.194a.979.979,0,0,0,.521-1.254l-2-5.115Z",
    transform: "translate(-13368.207 12767.512)",
    fill: "#fae8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16121",
    "data-name": "Trazado 16121",
    d: "M858.2,31.793a1.04,1.04,0,0,1-1.094,1.069c-2.277-.116-4.194-.265-5.653-.394-3.716-.329-2.2-.334-6.556-.785-2.907-.3-4.407-.385-5.945-1.511a7.073,7.073,0,0,1-1.727-1.835,11.1,11.1,0,0,1,4.581-7.355,10.775,10.775,0,0,1,6.986-1.727,10.489,10.489,0,0,1,4.22,1.583c4.441,2.922,5.113,8.528,5.188,10.956",
    transform: "translate(-13257.521 12857.785)",
    fill: "#f2b05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16124",
    "data-name": "Trazado 16124",
    d: "M909,38.02a9.514,9.514,0,0,0-8.06-.6,8.753,8.753,0,0,0-3.831,3.258,6.944,6.944,0,0,1,3.122-4.761,6.775,6.775,0,0,1,6.8-.044A3.83,3.83,0,0,1,909,38.02",
    transform: "translate(-13310.334 12843.872)",
    fill: "#c6783a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.d5543f443440fbd954de7d5124b0087f.svg";
export { ForwardRef as ReactComponent };